import { FileStarFourPointsOutlineIcon } from './FileStarFourPointsOutlineIcon';

/**
 * author: Jeff Anders
 * id D97DE718-4746-41B5-9168-4F5F08513158
 * name file-star-four-points-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-star-four-points-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileAutoOutlineIcon = FileStarFourPointsOutlineIcon;
export default FileAutoOutlineIcon